// Controller for contact form modal
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  // Open contact form modal
  // action: "contact-form#openModal"
  openModal(e) {
    e.preventDefault()
    const url = this.linkTarget.dataset.contactUrl
    const frame = document.getElementById('modal')
    if (frame) {
      frame.src = url
    }
  }
}
